module.exports = __webpack_public_path__ + "static/scale-model-of-alma's-lds-tours-llc-in-provo-utah-e92eedfd8df6ec92e9e1307903206c08.png";